import { Pipe, PipeTransform } from '@angular/core';
import * as momentTz from 'moment-timezone';
import * as moment from 'moment';
import { SUPPORTED_LANGUAGES } from '@app-core/constants/constants';

@Pipe({
  name: 'dateConversionV2',
})
export class DateConversionPipeV2 implements PipeTransform {
  public transform(
    startValue: any,
    endValue: any,
    timeZone: string = 'Local',
    format: string = 'MM/DD/YYYY HH:mm:ss',
    isReadableFormat: boolean = false,
    currentLanguage: string = 'en'
  ): any {
    let appliedFormat = format;

    moment.locale(this.mapLanguageKeyToLocale(currentLanguage));

    if (isReadableFormat) {
      if (format === 'DD/MM/YYYY HH:mm:ss') {
        appliedFormat = 'DD MMM YYYY';
      } else if (format === 'YYYY/MM/DD HH:mm:ss') {
        appliedFormat = 'YYYY MMM DD';
      } else {
        appliedFormat = 'MMM DD, YYYY';
      }
    }

    const parseDate = (val: any) => {
      if (!val) return null;

      let m: moment.Moment;

      if (val instanceof Date) {
        m = moment(val);
      } else if (timeZone === 'Local') {
        m = moment(val);
      } else {
        m = momentTz.tz(val, timeZone);
      }

      if (!isReadableFormat) {
        appliedFormat = appliedFormat.replace(/HH|mm|ss|:/g, '').trim();
        m.startOf('day');
      }

      return m;
    };

    if (startValue && endValue) {
      const start = parseDate(startValue);
      const end = parseDate(endValue);
      if (!start || !end) return '';

      if (isReadableFormat) {
        if (start.year() === end.year()) {
          if (start.month() === end.month()) {
            if (format === 'DD/MM/YYYY HH:mm:ss') {
              return `${start.format('DD')} - ${end.format('DD MMM, YYYY')}`;
            }
            if (format === 'YYYY/MM/DD HH:mm:ss') {
              return `${start.format('YYYY, MMM DD')} - ${end.format('DD')}`;
            }
            return `${start.format('MMM DD')} - ${end.format('DD, YYYY')}`;
          } else {
            if (format === 'DD/MM/YYYY HH:mm:ss') {
              return `${start.format('DD MMM')} - ${end.format('DD MMM, YYYY')}`;
            }
            if (format === 'YYYY/MM/DD HH:mm:ss') {
              return `${start.format('YYYY, MMM DD')} - ${end.format('MMM DD')}`;
            }
            return `${start.format('MMM DD')} - ${end.format('MMM DD, YYYY')}`;
          }
        } else {
          if (format === 'DD/MM/YYYY HH:mm:ss') {
            return `${start.format('DD MMM, YYYY')} - ${end.format('DD MMM, YYYY')}`;
          }
          if (format === 'YYYY/MM/DD HH:mm:ss') {
            return `${start.format('YYYY, MMM DD')} - ${end.format('YYYY, MMM DD')}`;
          }
          return `${start.format('MMM DD, YYYY')} - ${end.format('MMM DD, YYYY')}`;
        }
      } else {
        return `${start.format(appliedFormat)} - ${end.format(appliedFormat)}`;
      }
    }

    const parsedStart = parseDate(startValue);
    if (parsedStart) return parsedStart.format(appliedFormat);

    const parsedEnd = parseDate(endValue);
    if (parsedEnd) return parsedEnd.format(appliedFormat);

    return '';
  }

  private mapLanguageKeyToLocale(langKey: string): string {
    const language = SUPPORTED_LANGUAGES.find((lang) => lang.key === langKey);
    if (!language) return 'en';
    return langKey;
  }
}
